{
  "version": 1,
  "asset_id": "ff6ab1e0-bb34-464e-9343-ac0267a824e7",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/ff6ab1e0-bb34-464e-9343-ac0267a824e7/cp2000.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/ff6ab1e0-bb34-464e-9343-ac0267a824e7/cp2000.jpg",
  "original_filename": "cp2000.jpg",
  "size": 139978,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:46Z"
}
